export const SessionHistory = {
  setSessionHistory: "SET_SESSION_HISTORY_TABLE_DATA",
};
